<template>
  <div class="main-container layout-container flex center">
    <div class="main-top">

    </div>
    <div class="main-http404">
      <div class="pic-404">
        <img class="pic-404__parent" :src="four" alt="404" />
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">页面不存在!</div>
        <div class="bullshit__info">
          请检查您输入的网址是否正确
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import four from '@/assets/images/404.png'
</script>

<style lang="scss" scoped>
.main-container {
  height: 554px;
  background: #86c0f5;
}
.main-top{

}
.main-http404 {
   display: flex;
   justify-content: center;
   align-items: center;
  .pic-404 {
    width: 600px;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
  }
  .bullshit {
    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: white;
      opacity: 0;
      margin-bottom: 15px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__info {
      font-size: 18px;
      color: white;
      font-weight: bold;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
